export default {
    ENV: 'development',
    authApiUrl: 'https://localhost:5001',
    redirectUri: 'http://local.my.imaginelearning.com:8000/signin',
    auth0RedirectUri: 'https://test.my.imaginelearning.com/login/sso',
    auth0Audience: 'https://api.my.imaginelearning.com',
    auth0AuthorizeUrl: 'https://imaginelearning-test.auth0.com/authorize',
    auth0ClientId: 'vvTmU0S3zkSW3lihKyKkDMFDNOEVJ2aT',
    unityLaunchUrl: 'https://my.imaginelearning.com/player',
    pssUrl: 'https://localhost:5001/productSelection',
    imlpApiUrl: 'https://localhost:44350',
    oauthSsoUrl: 'https://localhost:44350/auth/sso/oauth',
    cleverSsoUrl: 'https://localhost:44350/auth/sso/clever',
    imlpIlApiUrl: 'https://localhost:44350',
    oauthSsoIlUrl: 'https://localhost:44350/auth/sso/oauth',
    cleverSsoIlUrl: 'https://localhost:44350/auth/sso/clever',
    permissionsApiUrl: 'https://testapi.imaginelearning.com/v1.0/permissions',
    configCatApiUrl: 'https://flag-proxy.platform-nonprod.imaginelearning.com',
    configCatSdkKey: 'configcat-proxy/axs-sso-imlp-dev',
    configCatPollIntervalSeconds: 60,
    configCatRequestTimeoutMs: 30000,
    configCatMaxRetries: 3
};
